import React, { useState, useCallback } from "react";
import { Button, Form, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { loginDetailsSelector } from "../../store/selectors/app.selector";
import ProfileService from "../../services/profile.service";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import AccountService from "../../services/accounts.service";
import { setTxnPendingCount } from "../../store/actions/app.action";
import { useTranslation } from "react-i18next";
import { store } from "../../store";
import { SET_LOGIN_DETAILS } from "../../store/constants";
import BANK_LOGO from "client/assets/LOGO/BANK_LOGO.png";
import PerfectScrollbar from "react-perfect-scrollbar";

export default function ProfileSelection() {
  const navigate = useNavigate();
  const loginDetails = useSelector(loginDetailsSelector);
  const dispatch = useDispatch();
  const [profileList, setProfileList] = useState([]);
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (loginDetails?.profileSelection?.length > 0) {
      form.setFieldsValue({
        profileId: loginDetails?.profileSelection[0]?.groupId,
        startIn: "DASHBOARD",
      });
      setProfileList([...loginDetails?.profileSelection]);
    }
  }, [loginDetails?.profileSelection]);

  const handleChange = useCallback(
    (option) => {
      try {
        const profileListCopy = [...loginDetails?.profileSelection];
        profileListCopy.forEach((element) => {
          if (element.groupId === option.profileId) {
            element.active = true;
          } else {
            element.active = false;
          }
        });
        store.dispatch({ type: SET_LOGIN_DETAILS, payload: loginDetails });
      } catch (error) {}
    },
    [profileList, loginDetails]
  );

  const getProfileDetails = useCallback(
    async (values) => {
      try {
        handleChange(values);
        const profileDet = profileList.find(
          (ele) => ele.groupId === values?.profileId
        );
        const response = await ProfileService.fetchProfileDetails({
          userGroupId: profileDet?.groupId,
          profileName: profileDet?.groupName,
        });

        if (response.status === 200) {
          // dispatch(
          //   setTxnPendingCount(
          //     response.data["customerDetails"].txnPendingCounts
          //   )
          // );
          // if (
          //   loginDetails["skipSecurityQuestions"] === true ||
          //   loginDetails["securityQuestions"] === true
          // ) {
          //   navigate("/security-questions");
          // } else {
          fetchAccounts();
          // }
        }
      } catch (error) {}
    },
    [profileList]
  );

  const fetchAccounts = useCallback(async () => {
    try {
      const { app } = store.getState();
      const response = await AccountService.getQuickAccounts("BA");
      if (response.status === 200) {
        console.log(app);
        const { mode, loginVerifyDetails } = app;

        if (["AA", "I"].indexOf(mode) > -1) {
          if (loginVerifyDetails?.routingPath === "loans") {
            navigate("/accounts", { state: "LA" });
            return;
          }
          if (loginVerifyDetails?.routingPath === "deposits") {
            navigate("/accounts", { state: "FD" });
            return;
          }
          navigate(`/${loginVerifyDetails?.routingPath}`);
        } else {
          if (
            ["send-money", "bill-payment"].indexOf(
              loginVerifyDetails?.routingPath
            ) < 0
          ) {
            if (loginVerifyDetails?.routingPath === "loans") {
              navigate("/accounts", { state: "LA" });
              return;
            }
            if (loginVerifyDetails?.routingPath === "deposits") {
              navigate("/accounts", { state: "FD" });
              return;
            }

            navigate(`/${loginVerifyDetails?.routingPath}`);
          } else {
            navigate("/dashboard");
          }
        }
      }
    } catch (error) {}
  }, []);

  return (
    <>
      <div className="auth-card">
      <PerfectScrollbar>
      <div className="py-5">
      <div className=" mb-4" align="center">
        <img src={BANK_LOGO} height={50} alt="Bank Logo" className="mb-2" />
      </div>
      <div style={{ margin: "40px" }}>
        <h5>
          {t("pages.profileSelection.profile_choose_title", {
            defaultValue: "Profile Choose",
          })}
        </h5>
        <p style={{ margin: "20px 0", fontSize: 14 }}>
          {t("pages.profileSelection.profile_choose_sub_title", {
            defaultValue:
              "Please choose the profile to proceed with the dashboard",
          })}
        </p>

        {/* <div>
        {profileList.map((option, idx) => (
          <div
            key={idx}
            className="profile-names"
            onClick={() => handleChange(option)}
          >
            <span>{option.profileName}</span>
            <span>
              {option.active && (
                <img width={20} src={radioCheckIcon} alt="check" />
              )}
              {!option.active && <IoRadioButtonOff style={{ fontSize: 22 }} />}
            </span>
          </div>
        ))}
      </div> */}

        <Form layout="vertical" form={form} onFinish={getProfileDetails}>
          <Form.Item
            label={t("pages.profileSelection.choose_profile", {
              defaultValue: "Choose profile",
            })}
            name="profileId"
            rules={[
              {
                required: true,
                message: t("errorMesssages.profile_required", {
                  defaultValue: "Profile is required",
                }),
              },
            ]}
          >
            <Select
              size="large"
              placeholder={t("pages.profileSelection.choose_profile", {
                defaultValue: "Choose profile",
              })}
            >
              {profileList.map((option, idx) => (
                <Select.Option key={idx} value={option.groupId}>
                  {option.groupName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          {/* <Form.Item
            label={t("pages.profileSelection.start_in", {
              defaultValue: "Start in",
            })}
            name="startIn"
            rules={[
              {
                required: true,
                message: t("errorMesssages.start_in_required", {
                  defaultValue: "Start in is required",
                }),
              },
            ]}
          >
            <Select
              size="large"
              placeholder={t("pages.profileSelection.start_in", {
                defaultValue: "Start in",
              })}
            >
              <Select.Option value={"DASHBOARD"}>Dashboard</Select.Option>
            </Select>
          </Form.Item> */}

          <div className="mt-4">
            <Button
              size="large"
              type="primary"
              className="login-button"
              block
              htmlType="submit"
            >
              {t("buttons.proceed_btn", {
                defaultValue: "Proceed",
              })}
            </Button>

            <Button
              type="link"
              className="mt-4"
              block
              onClick={() => {
                navigate("/login");
              }}
            >
              {t("buttons.cancel_btn", {
                defaultValue: "Cancel",
              })}
            </Button>
          </div>
        </Form>
      </div>
      </div>
      </PerfectScrollbar>
      </div>
    </>
  );
}
